import createParseMiddleware from './createParseMiddleware';
import { parseScopeResourceResponse } from 'utils/apiParser/scopeResourcesParser';
import { ScopeResource } from 'types/scopeResourcesTypes';

export const parseFetchScopeResourcesMiddleware = createParseMiddleware<ScopeResource>(parseScopeResourceResponse, 'scopeResources/fetchScopeResources');
